import { SESSION_USERNAME } from '../shared/utils/CommonConstants';
import { TOKEN_KEY } from '../shared/utils/SessionConstants';

// JWT claims as issued by AuthService.cs:
//   "UserId", "TenantId", "OrganizationId", "FirstName", "LastName"
// No "Role" claim exists in this token.
export interface DecodedToken {
  UserId?: string;
  OrganizationId?: string;
  FirstName?: string;
  LastName?: string;
  TenantId?: string;
  exp?: number;
}

export function decodeToken(token: string): DecodedToken {
  try {
    const base64 = token.split('.')[1];
    const decoded = JSON.parse(atob(base64));
    return decoded;
  } catch {
    return {};
  }
}

export function getCurrentUser(): DecodedToken {
  const token = localStorage.getItem(TOKEN_KEY) ?? sessionStorage.getItem(TOKEN_KEY) ?? '';
  if (!token) return {};
  return decodeToken(token);
}

export function getUserDisplayName(): string {
  // LoginService stores the full name after JWT decode — use it as the primary source.
  const stored = localStorage.getItem(SESSION_USERNAME);
  if (stored && stored.trim()) return stored.trim();

  // Fallback: decode JWT directly
  const user = getCurrentUser();
  const first = user.FirstName ?? '';
  const last  = user.LastName  ?? '';
  const full  = `${first} ${last}`.trim();
  if (full) return full;

  return 'User';
}

// No Role claim in JWT — callers can pass a role from the users API when available.
export function getUserRole(): string {
  return 'User';
}

export function getUserInitials(): string {
  const name = getUserDisplayName();
  return name
    .split(' ')
    .map((n: string) => n[0])
    .join('')
    .toUpperCase()
    .slice(0, 2);
}
